/**
 * cognitiveLoadReducer — Detects when the inference stack adds complexity without pastoral value.
 *
 * High load: many active signals + many blocks + analysis-hostile emotion context.
 * Outcome: pushes Kevia toward simplicity, presence, and naturalness.
 */

const ANTI_ANALYSIS_EMOTIONS = new Set([
  "duelo", "pérdida", "dolor_profundo", "silencio_emocional", "quebranto",
]);

export function assessCognitiveLoad({ signalCount, activeBlockCount, emotion, complexity, conflictType, familyDynamic, rhythmState, exhaustionState }) {
  let score = 0;

  if (signalCount >= 5)      score += 3;
  else if (signalCount >= 3) score += 1;

  if (activeBlockCount >= 5)      score += 2;
  else if (activeBlockCount >= 3) score += 1;

  if (ANTI_ANALYSIS_EMOTIONS.has(emotion?.dominant ?? "")) score += 2;

  const nonDefaultCount = [
    complexity !== "simple" && complexity != null,
    conflictType && conflictType !== "ninguno",
    familyDynamic && familyDynamic !== "ninguno",
    rhythmState && rhythmState !== "ritmo_saludable",
    exhaustionState && exhaustionState !== "estable",
  ].filter(Boolean).length;

  if (nonDefaultCount >= 4)      score += 2;
  else if (nonDefaultCount >= 2) score += 1;

  let loadLevel;
  let instruction = null;

  if (score >= 6) {
    loadLevel   = "high";
    instruction = "Responde con lo más esencial. Menos análisis, más presencia.";
  } else if (score >= 3) {
    loadLevel   = "medium";
    instruction = "Simplifica. Prioriza lo humano sobre lo técnico-pastoral.";
  } else {
    loadLevel = "low";
  }

  return { loadLevel, shouldSimplify: score >= 3, instruction, score };
}
